module.exports = __webpack_public_path__ + "img/kingdom.296db65b.svg";